import { FormatTypes } from 'Lib/Format';
import React from 'react';
import { Field, NumericInput, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';

const LoadCellEquipment = () => {
  return (
    <PageSection>
      <ListFieldSection>
        <Field input={<TextOutput />} label="Load Cell" name="Code" />
        <Field
          format={{ type: FormatTypes.AsEntered }}
          input={<NumericInput />}
          label="Readable to Nearest"
          name="Readability"
        />
      </ListFieldSection>
    </PageSection>
  );
};

export default LoadCellEquipment;
export { LoadCellEquipment };
